import { createContext, useContext } from 'react';
import { LogicRule } from '@types';

export type LogicTabContextType = {
  rules: LogicRule[];
  setRules: (rules: LogicRule[]) => void;
};

export const LogicTabContext = createContext<LogicTabContextType>(
  {} as LogicTabContextType,
);

export const useLogicTabContext = () => useContext(LogicTabContext);
